<template>
  <div>
    <el-collapse v-model="activeNames" @change="handleChange" class="pageViewBox">
      <el-collapse-item v-for="(comp, idx) in component" :title="comp.name" :name="comp.index" :key="idx">
        <!-- 111 -->
        <ul v-if="comp.index === '1'">
          <li v-for="(item, index) in comp.children"
            :class="isItem.index === '1' && activeClass(item, comp.index)" :key="`${comp.index}-${index}`"
            @click="handleClick(item, comp.index)">{{ item.name }}</li>
        </ul>
        <!-- 222 -->
        <template slot="title" v-if="comp.index === '2'">
          <span>{{ comp.name }}</span><i class="header-icon el-icon-plus" @click="(e)=>{handleTj(e, comp)}"></i>
        </template>
        <div v-if="comp.index === '2'" v-for="(item, index) in comp.children[0].data.list" :key="`${comp.index}-${index}`">
          <div class="list_title">
            <div><i class="el-icon-tickets"></i><span>{{ item.title }}</span></div>
            <div class="list_title_edit"><i class="el-icon-edit" style="margin-right: 6px;"
                @click="handleEdit(item)"></i>
              <i class="el-icon-delete" @click="handleDel(index)"></i>
            </div>
          </div>
          <ul>
            <li :class="activeClass(item.obj.listInfo, comp.index)"
              @click="handleClick(item.obj.listInfo, comp.index)">{{ item.obj.listInfo.name }}</li>
            <li :class="activeClass(item.obj.details, comp.index)"
              @click="handleClick(item.obj.details, comp.index)">{{ item.obj.details.name }}</li>
          </ul>
          <el-divider></el-divider>
        </div>
        <!-- 333 -->
        <ul v-if="comp.index === '3'">
          <li v-for="(item, index) in comp.children"
            :class="activeClass(item, comp.index)" :key="`${comp.index}-${index}`"
            @click="handleClick(item, comp.index)">
            {{ item.name }}</li>
          <!-- <li @click="handleClick('关于')">关于</li> -->
        </ul>
      </el-collapse-item>

    </el-collapse>

    <el-dialog title="新增文章页面" :visible.sync="dialogFormVisible" width="20%">
      <el-form :model="form" :rules="rules" label-width="80px">
        <el-form-item label="页面名称" prop="name">
          <el-input v-model="form.name" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="文章类型" prop="region">
          <el-select v-model="form.region" style="width: 100%;" placeholder="请选择">
            <el-option label="区域一" value="shanghai"></el-option>
            <el-option label="区域二" value="beijing"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleOK">确 定</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import PhoneBox from '../components/PhoneBox'
export default {
  name: 'pageView',
  components: { PhoneBox },
  props: {
    component: {}
  },
  data () {
    return {
      activeNames: ['1', '2', '3'],
      dialogFormVisible: false,
      form: {
        name: '',
        region: ''
      },
      rules: {
        name: [{ required: true, message: '请输入', trigger: 'blur' }],
        region: [{ required: true, message: '请选择', trigger: 'change' }]
      },
      dataList: [
        {
          title: '案例',
          lie: '列表',
          xq: '详情'
        }
      ],
      infoItme: null,
      isItem: {
        type: 1,
        index: '1'
      },
      idx: '1',
      wzList: {}
    }
  },

  mounted () {
    console.log('就收到回复', this.component)
  },

  methods: {
    handleChange: function () {},
    handleTj: function (e, comp) {
      e.stopPropagation()
      console.log('点击了吗')
      this.wzList = comp
      this.dialogFormVisible = true
    },
    handleOK: function () {
      console.log('确定', this.infoItme)
      if (this.infoItme) {
        const i = this.wzList.children[0].data.list.find(
          item => item.title === this.infoItme.title
        )
        i.title = this.form.name
      } else {
        this.wzList.children[0].data.list.push({
          title: this.form.name,
          icon: 'el-icon-tickets',
          obj: {
            listInfo: {
              name: '列表',
              typeName: 'modules',
              type: 1,
              setting: {
                title: '',
                component: ''
              },
              data: {}
            },
            details: {
              name: '详情',
              typeName: 'modules',
              type: 2,
              setting: {
                title: '',
                component: ''
              },
              data: {}
            }
          }
        })
      }

      console.log('生成内容', this.form.name)
      this.dialogFormVisible = false
      this.form.name = ''
      this.form.region = ''
      this.infoItme = null
    },
    handleEdit: function (item) {
      this.form.name = item.title
      this.infoItme = item
      this.dialogFormVisible = true
    },
    handleDel: function (index) {
      this.component.children[0].data.list.splice(index, 1)
    },
    handleClick: function (item, index) {
      this.isItem = {
        type: item.type,
        index: index
      }
      this.$emit('click', item)
    }
  },
  computed: {
    activeClass () {
      return (item, index) => {
        return this.isItem.index === index && this.isItem.type === item.type ? 'active' : ''
      }
    }
  }
}
</script>

<style scoped>
/deep/ .el-collapse-item__header {
  font-weight: 600;
  padding-left: 10px;
}

/deep/ .el-dialog__header {
  padding: 0;
  line-height: 54px;
  padding-left: 20px;
  background: #409eff;
}

/deep/ .el-dialog__title {
  color: #ffffff;
}

/deep/ .el-dialog__close {
  color: #ffffff !important;
}

ul,
li {
  list-style: none;
  padding: 0;
  margin: 0;
}

ul li {
  line-height: 38px;
  cursor: pointer;
  padding-left: 10px;
}

ul li:hover {
  background-color: #eef7ff;
}

.list_title {
  display: flex;
  justify-content: space-between;
  padding: 0 10px;
  color: #959ead;
  line-height: 38px;
  cursor: pointer;
}

.list_title_edit {
  display: none;
}

.list_title:hover {
  background-color: #eef7ff;
}

.list_title:hover .list_title_edit {
  display: block;
}

.header-icon {
  font-size: 16px;
  margin-left: 10px;
}

.header-icon:hover {
  color: #007bfc;
}

.active {
  background-color: #eef7ff;
}
</style>



// WEBPACK FOOTER //
// src/components/pageView.vue